export enum HttpMethodEnum {
    Get = 'Get',
    Post = 'Post',
    Put = 'Put',
    Delete = 'Delete'
}
